import React from 'react';
import classNames from '../../utility/classNames';

export default function TextLoader({ color = 'primary' }) {
  return (
    <span>
      <span
        className={classNames(
          `bg-${color}`,
          'inline-block w-1 h-1 mt-1 mr-1 rounded-full animate-[bounce_1.4s_0.1s_ease-in-out_infinite]'
        )}
      />
      <span
        className={classNames(
          `bg-${color}`,
          'inline-block w-1 h-1 mt-1 mr-1 rounded-full animate-[bounce_1.4s_0.4s_ease-in-out_infinite]'
        )}
      />
      <span
        className={classNames(
          `bg-${color}`,
          'inline-block w-1 h-1 mt-1 rounded-full animate-[bounce_1.4s_0.7s_ease-in-out_infinite]'
        )}
      />
    </span>
  );
}
